var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('leaflet-map',_vm._g({ref:"map",attrs:{"bounds":_vm.bounds,"animate":_vm.animate}},_vm.$listeners),[_c('leaflet-layer',{attrs:{"layer":_vm.tileLayer}}),_vm._t("default")],2),_vm._t("modal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }